
const GetSCMKpiReducer = (state = { type: 'LOADING_SCM_DETAIL_VIEW_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_SCM_DETAIL_VIEW_ACTION':
            return action
        default:
            return state
    }
}

const GetSCMMainReducer = (state = { type: 'LOADING_SCM_CARD_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_SCM_CARD_ACTION':
            return action
        default:
            return state
    }
}

export {
    GetSCMKpiReducer,
    GetSCMMainReducer
}